module.exports = ".box1 {\r\n    border: 1px solid gray;\r\n    min-height: 100px;\r\n    background-color: #eaecef;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-shipment/edit-shipment.component.css
// module id = ./src/app/edit-shipment/edit-shipment.component.css
// module chunks = main